import React from 'react';
import { useParams } from 'react-router-dom';
import EmbedOverallPerformance from './EmbedOverallPerformance';
import EmbedResourcePlanning from './EmbedResourcePlanning';
import EmbedTeamKPIs from './EmbedTeamKPIs';
import EmbedTeamMembers from './EmbedTeamMembers';
import EmbedAnnouncements from './EmbedAnnouncements';

const EmbedPage: React.FC = () => {
  const { section, widget } = useParams<{ section: string; widget?: string }>();

  switch (section) {
    case 'overall-performance':
      return <EmbedOverallPerformance widget={widget} />;
    case 'resource-planning':
      return <EmbedResourcePlanning />;
    case 'team-kpis':
      return <EmbedTeamKPIs />;
    case 'team-members':
      return <EmbedTeamMembers />;
    case 'announcements':
      return <EmbedAnnouncements />;
    default:
      return (
        <div className="text-center py-12">
          <h2 className="text-xl font-bold text-gray-800 mb-2">Widget not found</h2>
          <p className="text-gray-600">Unknown section: {section}</p>
        </div>
      );
  }
};

export default EmbedPage;
